/**
 * Canonical list of certification categories shared between worker
 * uploads and venue posting requirements.
 *
 * Mirror of `app/backend/shared/cert_categories.py:CERT_CATEGORIES`.
 * Workers pick one of these four when uploading a certification, and
 * venues pick the same set when requiring certs on a posting.
 */
export const CERT_CATEGORIES = [
  "SmartServe",
  "Food Handler Certificate",
  "WHMIS",
  "First Aid / CPR",
] as const;

export type CertCategory = (typeof CERT_CATEGORIES)[number];
